var render = function render(){var _vm=this,_c=_vm._self._c;return _c('input',{attrs:{"type":"text"},domProps:{"value":_vm.value},on:{"input":_vm.input,"keydown":_vm.keydown,"focus":_vm.focus,"blur":_vm.blur}})
}
var staticRenderFns = []

export { render, staticRenderFns }